import { formatDate } from '@angular/common'
import { ChangeDetectorRef, Component, OnInit, ViewRef,Input,Output,EventEmitter } from '@angular/core'
import { MatDialog } from '@angular/material'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { VidalService } from '../../../../../services'

import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'vidal'

@Component({
	selector: 'atyl-vidal',
	templateUrl: './vidal.component.html',
	styleUrls: ['./vidal.component.scss'],
})

@Stringable({
	path: 'views/partials/content/actions/vidal-actions-dialog',
	key: KEY,
})
export class VidalDialogComponent implements OnInit {
	
	@StringableValues(KEY) strings: any
    searchInput:any;
    copyInput:string='';
    table:any={};
    product:any={};
    
    inited = new EventEmitter<any>();
    
	constructor(
		private vidalService: VidalService,
		
		private changeDetectorRef: ChangeDetectorRef,
		public dialog: MatDialog,
		
		private activatedRoute: ActivatedRoute,
		private router: Router,
		
	) {
	}

	ngOnInit() {
        console.log("VidalComponent",this.strings);
        this.initTable();
       this.initProduct();
			

	}
	initProduct() {
		
	  this.product={
		  id: null,
		  name:"",
		  company:"",
		  category:"",
		  posology:[],
		  options:[],
		  options_keys:[]
	    }
	  
	 
	}
	
	initTable() {
		
	  this.table=this.strings.table;
	  
	  console.log("initTable",this.table)
	}
	
	setData(page:number) {
		this.table.data=[];
		this.table.currentPage=page;
		let begin:number=this.table.currentPage*this.table.pagination;
		let end:number=(this.table.currentPage+1)*this.table.pagination;
		
		
		for(let i:number=begin;i<end;i++)
		    if (this.table.datas[i]!=undefined)
		    	this.table.data.push(this.table.datas[i]);
		this.table.loading=false;   	
	}
	
	searchData(event:any) {
		if (this.searchInput.length>0) {
			this.table.loading=true;
			this.table.datas=[];
			this.table.data=[];
			this.table.currentPage=0;
			this.table.length=0;
			
			this.vidalService.search(this.searchInput).subscribe((res: JSONRpcResponse) => {
				console.log("searchData",res);
				if (res.result) {
					this.table.datas=res.result;
					this.table.length=res.result.length;
					this.setData(this.table.currentPage);
					
					
				}
				this.table.loading=false;
				this.changeDetectorRef.detectChanges()
			})
		}
	}
	
	getInitedEmitter() {
		return this.inited
	}

	onPaged(event: any) {
		//this.onPageClicked.emit(event)
		console.log("onPaged",event)
		this.setData(event.currentPage);
		
		this.changeDetectorRef.detectChanges()
	}
	rowClicked(event: any) {
	//	this.onRowClicked.emit(event)
	    
	   console.log("rowClicked",event);
		this.initProduct();
	   if (event.ID!=undefined) {
		     this.product.id=event.ID;
		     this.product.name=event.title;
		  let _options={
				posology: true,
				documentOpt: true,
			};
			
			this.table.loading=true;
			this.vidalService.product(event.ID,_options).subscribe((res: JSONRpcResponse) => {
				console.log("rowClicked product",res);
				if (res.result) {
					
					this.product=res.result;
					this.product.options=[];
					this.product.options_keys=[];
					
					let opts:any={};
					if (this.product.posology) {
						
						for(let i:number=0;i<this.product.posology.length;i++) {
						//	console.log("rowClicked",this.product.posology[i].alertType);
							if (this.product.posology[i].alertType!=undefined) {
							//	console.log(this.product.posology[i].alertType,this.product.posology[i]);
								if (opts[this.product.posology[i].alertType]==undefined)
								   opts[this.product.posology[i].alertType]=[];
								let opt={
									"key":this.product.posology[i].alertType,
					                 "title_html": this.product.posology[i].alertType,
					                 "title_text": this.product.posology[i].alertType,
					                 "text": this.product.posology[i].content,
					                 "html":this.product.posology[i].content
									
								}   
								   
								opts[this.product.posology[i].alertType].push(opt);
							}
						}
						
					}
					if (this.product.documentOpt 
					&& this.product.documentOpt.content_parsed !=undefined
					&& this.product.documentOpt.content_parsed.length>0
					) {
					   for(let i:number=0;i<this.product.documentOpt.content_parsed.length;i++) {	
						   let opt=this.product.documentOpt.content_parsed[i];
						   opts[opt.title_text]=[];
						   opts[opt.title_text].push(opt);
							
					   }
					}
					
					 Object.keys(opts).forEach(key => {
				             console.log(key, this.product.options[key]);
				             
				             this.product.options_keys.push(key);
				             this.product.options.push(opts[key]);
					});
					
					
					console.log("product",this.product)
					
					 
					
				}
				this.table.loading=false;
				this.changeDetectorRef.detectChanges()
			})
	   
	  
		}
	 
	}
	
	headerClicked(event: any) {
		//this.onHeaderClicked.emit(event)
	}
	
	checkLoaded(load: any) {
		//this.inited.emit(this.result.currentValue)
		this.changeDetectorRef.detectChanges()
	}
	
	getClassProducts() {
		let col:number=12;
		if (this.product.id)
		   col=6;
		return "col-"+col;   
	}
	
	coypData(event:any) {
		
		if (typeof (navigator.clipboard) == 'undefined') {
		    console.log('navigator.clipboard');
		    var textArea = document.createElement("textarea");
		    textArea.value = this.copyInput;
		    textArea.style.position = "fixed";  //avoid scrolling to bottom
		    document.body.appendChild(textArea);
		    textArea.focus();
		    textArea.select();
		
		    try {
		        var successful = document.execCommand('copy');
		        var msg = successful ? 'successful' : 'unsuccessful';
		        console.log(msg);
		    } catch (err) {
		        console.log('Was not possible to copy te text: ', err);
		    }
		
		    document.body.removeChild(textArea)
		    return;
		}
			
		navigator.clipboard.writeText(this.copyInput).then(function () {
		    console.log(`successful!`);
		}, function (err) {
		   console.log('unsuccessful!', err);
		});
				
				navigator.clipboard.writeText(this.copyInput).then().catch(e => console.error(e));
	}
		
	addData(event:any,obj:any) {
		let toadd:string;
		console.log("addData",event,obj)
		if (obj=="name") {
		     
		       toadd=this.product.name;
		} else {
			if (this.product.options[obj]!=undefined
			   	&& 	this.product.options[obj].length>0
			) {
				let opt=this.product.options[obj];
				toadd="";
				for(let i=0;i<opt.length;i++)
				    toadd+=opt[i].text+  "\r";
			}
		}
		this.copyInput+=toadd;
	}	
		
}
	
	
